import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { PaginationListResponse } from 'src/app/_models/pagination-list-response';
import { environment } from 'src/environments/environment';
import { GetOfertasTrabajoDetalleResponse } from '../../egresado/responses/get-detalles-oferta-egr-response';
import { GetEmpresaListaOfertasActivasResponse } from '../../empresa/responses/get-ofertas-activas-emp-response';
import { InsertAdminRequest } from '../requests/insert-admin-request';
import { InsertConocimientoRequest } from '../requests/insert-conocimiento-request';
import { InsertDocenteRequest } from '../requests/insert-docente-request';
import { InsertEgresadoRequest } from '../requests/insert-egresado-request';
import { InsertHabilidadRequest } from '../requests/insert-habilidad-request';
import { UpdateAdmOfertaValidacionRequest } from '../requests/update-adm-oferta-validacion-request';
import { UpdateConocimientoRequest } from '../requests/update-conocimiento-request';
import { UpdateHabilidadRequest } from '../requests/update-habilidad-request';
import { GetAdministradorEgresadoMatriculaResponse } from '../responses/get-adm-egresado-user-response';
import { GetDashComparacionSueldoAreaResponse } from '../responses/get-dash-compar-sueld-response';
import { GetDashTopConocimientosResponse } from '../responses/get-dash-conocimientos-response';
import { GetDashTopHabilidadesResponse } from '../responses/get-dash-habilidades-response';
import { GetDashPostulacionesGeneroResponse } from '../responses/get-dash-postulaciones-gen-response';
import { GetDashResultPostulacionesResponse } from '../responses/get-dash-postulaciones-response';
import { GetDashSalarioResponse } from '../responses/get-dash-salario-response';
import { GetDashTopAreasResponse } from '../responses/get-dash-top-areas-response';
import { GetDashVacantesResponse } from '../responses/get-dash-vacantes-response';
import { GetDetallesEmpresaResponse } from '../responses/get-detalles-empresa-response';
import { GetEmpresasAfiliadasResponse } from '../responses/get-empresas-afiliadas-response';
import { GetAdminListaResponse } from '../responses/get-lista-admin-response';
import { GetListaConocimientosResponse } from '../responses/get-lista-conocimientos-response';
import { GetDocenteListaResponse } from '../responses/get-lista-docente-response';
import { GetListaHabilidadesResponse } from '../responses/get-lista-habilidades-response';
import { GetOfertasActivasAdmResponse } from '../responses/get-ofertas-activas-adm-response';
import { GetOfertasNuevasAdmResponse } from '../responses/get-ofertas-nuevas-adm-response';
import { InsertAdminResponse } from '../responses/insert-admin-response';
import { InsertConocimientoResponse } from '../responses/insert-conocimiento-response';
import { InsertDocenteResponse } from '../responses/insert-docente-response';
import { InsertEgresadoResponse } from '../responses/insert-egresado-response';
import { InsertHabilidadResponse } from '../responses/insert-habilidad-response';
import { UpdateConocimientoResponse } from '../responses/update-conocimiento-response';
import { UpdateHabilidadResponse } from '../responses/update-habilidad-response';
import { GetDashEgresadosTrabajandoResponse } from '../responses/get-adm-egresados-trabaja-response';
import { GetEstadoPostulacionesEgresadosResponse } from '../responses/get-estado-postulaciones-egresado-response';
import { InsertAdminEmpresaRequest } from '../requests/insert-empresa-admin-request';
import { InsertAdminEmpresaResponse } from '../responses/insert-empresa-admin-response';
import { UpdateEstadoValidacionOfertaEmpresaRequest } from '../requests/update-estado-validacion-oferta-empresa-request';
import { UpdateEstadoValidacionOfertaEmpresaResponse } from '../responses/update-estado-validacion-oferta-empresa-response';

@Injectable({
  providedIn: 'root'
})
export class AdminService implements OnDestroy{
  controller = 'CuentaAdministrador';
  controllerNotification = 'OfertaDeTrabajoNotificacion';

  private destroy$: Subject<void> = new Subject<void>();
  constructor(private _http: HttpClient) {}

  getOfertasNuevas(): Observable<PaginationListResponse<GetOfertasNuevasAdmResponse>> {
    return this._http.get<PaginationListResponse<GetOfertasNuevasAdmResponse>>(
      `${environment.url_api}${this.controller}/list-ofertas-nuevas`      
    ).pipe(takeUntil(this.destroy$));
  }

  getOfertasNuevasByPage(page): Observable<PaginationListResponse<GetOfertasNuevasAdmResponse>> {
    let parameters = { 'skip' : page.toString()}
    return this._http.get<PaginationListResponse<GetOfertasNuevasAdmResponse>>(
      `${environment.url_api}${this.controller}/list-ofertas-nuevas`,{params:parameters}      
    ).pipe(takeUntil(this.destroy$));
  }

  getOfertasActivas(): Observable<PaginationListResponse<GetOfertasActivasAdmResponse>> {
    return this._http.get<PaginationListResponse<GetOfertasActivasAdmResponse>>(
      `${environment.url_api}${this.controller}/list-ofertas-activas`      
    ).pipe(takeUntil(this.destroy$));
  }

  getOfertasActivasByPage(page): Observable<PaginationListResponse<GetOfertasActivasAdmResponse>> {
    let parameters = { 'skip' : page.toString()};  
    return this._http.get<PaginationListResponse<GetOfertasActivasAdmResponse>>(
      `${environment.url_api}${this.controller}/list-ofertas-activas`,{params:parameters}      
    ).pipe(takeUntil(this.destroy$));
  }

  getEmpresasAfiliadas(): Observable<PaginationListResponse<GetEmpresasAfiliadasResponse>> {
    return this._http.get<PaginationListResponse<GetEmpresasAfiliadasResponse>>(
      `${environment.url_api}${this.controller}/list-empresas-afiliadas`      
    ).pipe(takeUntil(this.destroy$));
  }

  getEmpresasAfiliadasByPage(page): Observable<PaginationListResponse<GetEmpresasAfiliadasResponse>> {
    let parameters = { 'skip' : page.toString()};  
    return this._http.get<PaginationListResponse<GetEmpresasAfiliadasResponse>>(
      `${environment.url_api}${this.controller}/list-empresas-afiliadas`,
      {params:parameters}     
    ).pipe(takeUntil(this.destroy$));
  }

  agregarAdministrador(request: InsertAdminRequest): Observable<InsertAdminResponse> {
    return this._http.post<InsertAdminResponse>(
      `${environment.url_api}${this.controller}/add-admin`,
      request
    ).pipe(takeUntil(this.destroy$));
  }

  agregarEgresado(request: InsertEgresadoRequest ): Observable<InsertEgresadoResponse> {
    return this._http.post<InsertEgresadoResponse>(
      `${environment.url_api}${this.controller}/add-account-egresado`,
      request
    ).pipe(takeUntil(this.destroy$));
  }

  agregarDocente(request: InsertDocenteRequest): Observable<InsertDocenteResponse> {
    return this._http.post<InsertDocenteResponse>(
      `${environment.url_api}${this.controller}/add-docente`,
      request
    ).pipe(takeUntil(this.destroy$));
  }

  agregarEmpresa(request: InsertAdminEmpresaRequest): Observable<InsertAdminEmpresaResponse> {
    return this._http.post<InsertAdminEmpresaResponse>(
      `${environment.url_api}${this.controller}/add-account-empresa`,
      request
    ).pipe(takeUntil(this.destroy$));
  }
  
  validarUsuario(request:string): Observable<number> {
    let params = { 'usuario' : request};
    return this._http.get<number>(
      `${environment.url_api}${this.controller}/get-usuario-validar`,
      {params:params}
    ).pipe(takeUntil(this.destroy$));
  }

  getOfertasPublicadasEmpresa(request: number): Observable<PaginationListResponse<GetEmpresaListaOfertasActivasResponse>> {
    let parameters = { idUsuario : request};
    return this._http.get<PaginationListResponse<GetEmpresaListaOfertasActivasResponse>>(
      `${environment.url_api}${this.controller}/list-ofertas-publicadas-empresa`,
      {params:parameters}
    ).pipe(takeUntil(this.destroy$));
  }

  getOfertasPublicadasEmpresaByPage(request: number,page): Observable<PaginationListResponse<GetEmpresaListaOfertasActivasResponse>> {
    let parameters = { idUsuario : request, 'skip' : page.toString()};
    return this._http.get<PaginationListResponse<GetEmpresaListaOfertasActivasResponse>>(
      `${environment.url_api}${this.controller}/list-ofertas-publicadas-empresa`,
      {params:parameters}
    ).pipe(takeUntil(this.destroy$));
  }

  getEstadoPostulacionesEgresado(): Observable<PaginationListResponse<GetEstadoPostulacionesEgresadosResponse>> {
    return this._http.get<PaginationListResponse<GetEstadoPostulacionesEgresadosResponse>>(
      `${environment.url_api}${this.controller}/get-estado-postulaciones-egresados`)
      .pipe(takeUntil(this.destroy$));
  }

  getEstadoPostulacionesByEgresado(request: number): Observable<GetEstadoPostulacionesEgresadosResponse[]> {
    let parameters = { idUsuario : request};
    return this._http.get<GetEstadoPostulacionesEgresadosResponse[]>(
      `${environment.url_api}${this.controller}/get-estado-postulaciones-by-egresado`,
      {params:parameters})
      .pipe(takeUntil(this.destroy$));
  }

  getEstadoPostulacionesEgresadoByPage(page): Observable<PaginationListResponse<GetEstadoPostulacionesEgresadosResponse>> {
    let parameters = { 'skip' : page.toString()};
    return this._http.get<PaginationListResponse<GetEstadoPostulacionesEgresadosResponse>>(
      `${environment.url_api}${this.controller}/get-estado-postulaciones-egresados`,
      {params:parameters})
      .pipe(takeUntil(this.destroy$));
  }


  getListaAdmins(): Observable<GetAdminListaResponse[]> {
    return this._http.get<GetAdminListaResponse[]>(
      `${environment.url_api}${this.controller}/list-admin`
    ).pipe(takeUntil(this.destroy$));
  }

  getListaDocentes(): Observable<GetDocenteListaResponse[]> {
    return this._http.get<GetDocenteListaResponse[]>(
      `${environment.url_api}${this.controller}/list-docente`
    ).pipe(takeUntil(this.destroy$));
  }

  getDetallesEmpresa(idUsuario:number): Observable<GetDetallesEmpresaResponse> {
    let parameters = { idUsuarioEmpresa: idUsuario };
    return this._http.get<GetDetallesEmpresaResponse>(
      `${environment.url_api}${this.controller}/detalles-empresa`,
      { params: parameters }
    ).pipe(takeUntil(this.destroy$));
  }

  dashGetVacantes(): Observable<GetDashVacantesResponse> {
    return this._http.get<GetDashVacantesResponse>(
      `${environment.url_api}${this.controller}/dash-vacantes`
    ).pipe(takeUntil(this.destroy$));
  }

  dashGetSalario(): Observable<GetDashSalarioResponse> {
    return this._http.get<GetDashSalarioResponse>(
      `${environment.url_api}${this.controller}/dash-salario`
    ).pipe(takeUntil(this.destroy$));
  }

  dashGetTopAreas(): Observable<GetDashTopAreasResponse[]> {
    return this._http.get<GetDashTopAreasResponse[]>(
      `${environment.url_api}${this.controller}/dash-top`
    ).pipe(takeUntil(this.destroy$));
  }

  dashGetPostulacionAvg(): Observable<GetDashResultPostulacionesResponse> {
    return this._http.get<GetDashResultPostulacionesResponse>(
      `${environment.url_api}${this.controller}/dash-postulaciones`
    ).pipe(takeUntil(this.destroy$));
  }

  dashGetPostulacionGeneroAvg(): Observable<GetDashPostulacionesGeneroResponse[]> {
    return this._http.get<GetDashPostulacionesGeneroResponse[]>(
      `${environment.url_api}${this.controller}/dash-genero`
    ).pipe(takeUntil(this.destroy$));
  }

  dashGetTopHabilidadeds(): Observable<GetDashTopHabilidadesResponse[]> {
    return this._http.get<GetDashTopHabilidadesResponse[]>(
      `${environment.url_api}${this.controller}/dash-top-habilidades`
    ).pipe(takeUntil(this.destroy$));
  }

  dashGetTopConocimientos(): Observable<GetDashTopConocimientosResponse[]> {
    return this._http.get<GetDashTopConocimientosResponse[]>(
      `${environment.url_api}${this.controller}/dash-top-conocimientos`
    ).pipe(takeUntil(this.destroy$));
  }

  dashComparacionSueldoArea(): Observable<GetDashComparacionSueldoAreaResponse[]> {
    return this._http.get<GetDashComparacionSueldoAreaResponse[]>(
      `${environment.url_api}${this.controller}/dash-comparacion-sueldos`
    ).pipe(takeUntil(this.destroy$));
  }

  dashEgresadosTrabajando(): Observable<GetDashEgresadosTrabajandoResponse> {
    return this._http.get<GetDashEgresadosTrabajandoResponse>(
      `${environment.url_api}${this.controller}/dash-egresados-trabajando`
    ).pipe(takeUntil(this.destroy$));
  }
  
  getDetallesOferta(request: number): Observable<GetOfertasTrabajoDetalleResponse> {
    let parameters = { idOferta : request};
    return this._http.get<GetOfertasTrabajoDetalleResponse>(
      `${environment.url_api}${this.controller}/get-detalles-oferta`,
      {params:parameters}
    ).pipe(takeUntil(this.destroy$));
  }

  updateEstadoOferta(request: UpdateAdmOfertaValidacionRequest): Observable<boolean> {
    return this._http.put<boolean>(
      `${environment.url_api}${this.controllerNotification}/update-status-offer`, 
      request).pipe(takeUntil(this.destroy$));
  }

  getListaConocimientos(): Observable<GetListaConocimientosResponse[]> {
    return this._http.get<GetListaConocimientosResponse[]>(
      `${environment.url_api}${this.controller}/list-conocimientos`
    ).pipe(takeUntil(this.destroy$));
  }

  agregarConocimiento(request: InsertConocimientoRequest) : Observable<InsertConocimientoResponse> {
    return this._http.post<InsertConocimientoResponse>(
      `${environment.url_api}${this.controller}/add-conocimiento`,
      request
    ).pipe(takeUntil(this.destroy$));
  }

  actualizarConocimiento(request: UpdateConocimientoRequest) : Observable<UpdateConocimientoResponse> {
    return this._http.put<UpdateConocimientoResponse>(
      `${environment.url_api}${this.controller}/update-conocimiento`,
      request
    ).pipe(takeUntil(this.destroy$));
  }

  getListaHabilidades(): Observable<GetListaHabilidadesResponse[]> {
    return this._http.get<GetListaHabilidadesResponse[]>(
      `${environment.url_api}${this.controller}/list-habilidades`
    ).pipe(takeUntil(this.destroy$));
  }

  agregarHabilidad(request: InsertHabilidadRequest) : Observable<InsertHabilidadResponse> {
    return this._http.post<InsertHabilidadResponse>(
      `${environment.url_api}${this.controller}/add-habilidad`,
      request
    ).pipe(takeUntil(this.destroy$));
  }

  actualizarHabilidad(request: UpdateHabilidadRequest) : Observable<UpdateHabilidadResponse> {
    return this._http.put<UpdateHabilidadResponse>(
      `${environment.url_api}${this.controller}/update-habilidad`,
      request
    ).pipe(takeUntil(this.destroy$));
  }

  getEgresadoByUser(username :string): Observable<GetAdministradorEgresadoMatriculaResponse> {
    let parameters = { 'usuario' : username.toString()};  
    return this._http.get<GetAdministradorEgresadoMatriculaResponse>(
      `${environment.url_api}${this.controller}/get-egresado`,
      {params:parameters}      
    ).pipe(takeUntil(this.destroy$));
  }

  updateEstadoValidacionOfertaEmpresa(request: UpdateEstadoValidacionOfertaEmpresaRequest): Observable<UpdateEstadoValidacionOfertaEmpresaResponse> {
    return this._http.put<UpdateEstadoValidacionOfertaEmpresaResponse>(
      `${environment.url_api}${this.controller}/update-estado-validacion-oferta-empresa`,
      request
    ).pipe(takeUntil(this.destroy$));
  } 
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
